// Keeps the mimbox table's filters while the user is on the pages they open from it, so the
// "back to the list" actions return to the same filtered table. Leaving those pages forgets them,
// so the table opened any other way (sidebar, link) starts clean.
import { parseQuery, stringifyQuery } from "vue-router";
import type { RouteLocationNamedRaw, RouteLocationNormalized } from "vue-router";

const KEY = "mbq";
// The pages opened from the table and returned from, where its filters are kept
const FLOW = ["mimbox", "mimbox-edit", "mimbox-new", "mimbox-troubleshoot-error"];

const inFlow = (route: RouteLocationNormalized) => FLOW.includes(route.name as string);

/** Call after each navigation: save the table's query when entering the flow, clear it when leaving */
export function trackMimboxTableQuery(to: RouteLocationNormalized, from: RouteLocationNormalized) {
  try {
    if (!inFlow(to)) {
      sessionStorage.removeItem(KEY);
    } else if (from.name === "mimboxes") {
      const query = stringifyQuery(from.query);
      if (query) sessionStorage.setItem(KEY, query);
      else sessionStorage.removeItem(KEY);
    }
  } catch {
    // Without storage the back actions open the table unfiltered
  }
}

/** The mimbox table, with the filters it had when the user left it for the current page */
export function mimboxTableLocation(): RouteLocationNamedRaw {
  let query = "";
  try {
    query = sessionStorage.getItem(KEY) ?? "";
  } catch {
    // Without storage, open the table unfiltered
  }
  return { name: "mimboxes", query: parseQuery(query) };
}
